<template>
  <div class="common-page role-permission-management">
    <div class="staff-left">
      <el-input class="tree-search" v-model="searchKey" style="width: 100%" clearable placeholder="请输入角色名称">
        <i class="el-icon-search" slot="prefix"></i>
      </el-input>
      <div class="role-box">
        <div v-for="item in roleData" :key="item.roleId">
          <div
            v-show="item.isShow"
            class="role-box-list"
            :class="
              selectRole.roleId === item.roleId ? 'role-box-list-selected' : ''
            "
            @click="handleSelectRole(item)">
            <el-image :src="peopleIcon" class="people-icon"></el-image>
            <span>{{ item.roleName }}</span>
          </div>
        </div>
      </div>
      <div class="add-dept" @click="addDept">新增角色</div>
    </div>
    <div class="staff-right">
      <div class="search-form-box">
        <div class="top-box">
          <div class="top-box-left">
            <el-image :src="companyImage" class="company-image"></el-image>
            <div class="company-box">
              <span class="name">
                {{ selectRole.roleName }}
              </span>
            </div>
          </div>
          <div class="top-box-right" v-if="!selectRole.internal">
            <span class="box-1" @click="editDept">编辑角色</span>
            <span class="box-1" @click="deleteDept">删除角色</span>
          </div>
        </div>
      </div>
      <div class="custom-table-box" v-loading="loading">
        <div class="custom-role-header">
          <div class="list-1">
            <el-checkbox
              style="margin-left: -0.12rem; margin-right: 0.1rem"
              :disabled="!isEdit"
              @change="handleChange1($event)"
              v-model="isCheckedAll"></el-checkbox>
            应用名称
          </div>
          <div class="list-2">子应用名称</div>
          <div class="list-3">功能权限</div>
          <span class="edit-or-save" @click="isEdit ? handleSavePer() : handleEditPer()">
            {{ isEdit ? "保存配置" : "编辑配置" }}
          </span>
        </div>
        <div class="custom-role-content">
          <div class="role-table-box" v-for="(item, index) in permissionData" :key="item.menuId">
            <div class="list-table-1">
              <el-checkbox :disabled="!isEdit" @change="handleChange1($event, item, index)" v-model="item.isChecked">
                {{ item.menuName }}
              </el-checkbox>
            </div>
            <template v-if="item.children && item.children.length > 0">
              <div class="list-table-2">
                <div class="table-2-1" v-for="(item2, index2) in item.children" :key="item2.menuId">
                  <div class="list-2-1">
                    <div class="list">
                      <div class="list-box">
                        <el-checkbox
                          :disabled="!isEdit"
                          @change="handleChange2($event, item2, index, index2)"
                          v-model="item2.isChecked">
                          {{ item2.menuName }}
                        </el-checkbox>
                      </div>
                    </div>
                    <div class="list2">
                      <template v-for="item3 in item2.permissions">
                        <el-checkbox
                          :key="item3.menuId"
                          :disabled="!isEdit"
                          @change="handleChange3($event, item3, index, index2)"
                          v-model="item3.isChecked">
                          {{ item3.menuName }}
                        </el-checkbox>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="list-table-2">
                <div class="table-2-1">
                  <div class="list-2-1">
                    <div class="list">
                      <div class="list-box"></div>
                    </div>
                    <div class="list2">
                      <template v-for="item2 in item.permissions">
                        <el-checkbox
                          :key="item2.menuId"
                          :disabled="!isEdit"
                          @change="handleChange4($event, item2, index)"
                          v-model="item2.isChecked">
                          {{ item2.menuName }}
                        </el-checkbox>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!--    添加或编辑-->
    <addOrEditRole ref="addOrEditRole"></addOrEditRole>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEditRole from "./addOrEditRole.vue";
import {
  deleteInfo,
  getPage as getRoleData,
  getPage,
  getRoleMenu,
  savePermissions,
} from "./api";

export default {
  name: "RolePermissionManagement",
  components: {
    OperateBox,
    CustomTable,
    addOrEditRole,
  },
  data() {
    return {
      peopleIcon: require("@/assets/imgs/people_icon.png"),
      companyImage: require("@/assets/imgs/people.png"),
      treeImage: require("@/assets/imgs/tree.png"),
      haveRole: false,
      getTableMethod: getPage,
      deleteMethod: deleteInfo,
      isImmediatelyGetData: false,
      tableColumn: [
        {
          label: "员工姓名",
          prop: "username",
          show: true,
        },
        {
          label: "手机号码",
          prop: "phone",
          show: true,
        },
        {
          label: "所属部门",
          prop: "deptName",
          show: true,
        },
        {
          label: "岗位标签",
          prop: "roleName",
          show: true,
        },
        {
          label: "系统角色",
          prop: "roleName",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "200px",
          scopeStatus: true,
          show: true,
        },
      ],
      selectRole: {
        roleId: "",
        roleName: "",
      },
      roleData: [],
      saveRoleData: [],
      permissionData: [],
      searchKey: "",
      isEdit: false,
      isCheckedAll: false,
      loading: false,
    };
  },
  watch: {
    searchKey: function (val) {
      this.roleData.forEach((item) => {
        if (!item.roleName.includes(val)) {
          item.isShow = false;
        } else {
          item.isShow = true;
        }
      });
    },
    isCheckedAll: function (val) {
      if (this.permissionData && this.permissionData.length > 0) {
        this.permissionData.forEach((item, index) => {
          item.isChecked = val;
          this.handleChange1(val, item, index);
        });
      }
    },
  },
  created() {
    this.getRoleData();
  },
  mounted() {},
  methods: {
    handleEditPer() {
      this.isEdit = true;
    },
    handleSavePer() {
      let params = {
        menuIds: this.getAllCheckedMenuId(),
        roleId: this.selectRole.roleId,
      };
      this.loading = true;
      savePermissions(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("保存成功");
          }
        })
        .finally(() => {
          this.loading = false;
        });
      this.isEdit = false;
      this.isCheckedAll = false;
    },
    handleChange1(e, item, index) {
      // 第二层全变化
      if (
        this.permissionData[index].children &&
        this.permissionData[index].children.length > 0
      ) {
        this.permissionData[index]?.children.forEach((item) => {
          item.isChecked = e;
          if (item.permissions && item.permissions.length > 0) {
            item.permissions.forEach((item2) => {
              item2.isChecked = e;
            });
          }
        });
      } else {
        if (
          this.permissionData[index].permissions &&
          this.permissionData[index].permissions.length > 0
        ) {
          this.permissionData[index].permissions.forEach((item2) => {
            item2.isChecked = e;
          });
        }
      }
    },
    handleChange2(e, item, index, index2) {
      let isAllChecked = false;
      this.permissionData[index].children.forEach((item) => {
        if (item.isChecked) {
          isAllChecked = true;
        }
      });
      if (
        this.permissionData[index].children[index2].permissions &&
        this.permissionData[index].children[index2].permissions.length > 0
      ) {
        this.permissionData[index].children[index2].permissions.forEach(
          (item2) => {
            item2.isChecked = e;
          }
        );
      }
      this.permissionData[index].isChecked = isAllChecked;
    },
    handleChange3(e, item, index, index2, index3) {
      let isAllChecked = false;
      this.permissionData[index].children[index2].permissions.forEach(
        (item) => {
          if (item.isChecked) {
            isAllChecked = true;
          }
        }
      );
      // this.permissionData[index].children[index2].isChecked = isAllChecked;
      // this.permissionData[index].isChecked = isAllChecked;
    },
    handleChange4(e, item2, index) {
      this.permissionData[index].isChecked = e;
    },
    getRoleData() {
      getRoleData().then((res) => {
        if (res.code === 200) {
          res.data = res.data.map((item) => ({
            ...item,
            isShow: true,
          }));
          this.searchKey = "";
          this.roleData = res.data;
          if (!this.selectRole.roleId) {
            if (this.roleData && this.roleData.length > 0) {
              this.handleSelectRole(this.roleData[0]);
            }
          }
        }
      });
    },
    handleSelectRole(item) {
      this.isEdit = false;
      if (this.selectRole.roleId === item.roleId) {
        return;
      }
      this.selectRole = Object.assign({}, item);
      this.getPermission(item.roleId);
    },
    addDept() {
      this.$refs.addOrEditRole.init();
    },
    editDept() {
      this.$refs.addOrEditRole.init(this.selectRole);
    },
    getPermission(roleId) {
      this.loading = true;
      getRoleMenu(roleId)
        .then((res) => {
          if (res.code === 200) {
            this.permissionData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAllCheckedMenuId() {
      let menuIds = [];
      if (this.permissionData && this.permissionData.length > 0) {
        this.permissionData.forEach((item) => {
          if (item.isChecked) {
            menuIds.push(item.menuId);
          }
          if (item.children && item.children.length > 0) {
            item.children.forEach((item2) => {
              if (item2.isChecked) {
                menuIds.push(item2.menuId);
              }
              if (item2.children && item2.children.length > 0) {
                item2.children.forEach((item3) => {
                  if (item3.isChecked) {
                    menuIds.push(item3.menuId);
                  }
                });
              }
              if (item2.permissions && item2.permissions.length > 0) {
                item2.permissions.forEach((item3) => {
                  if (item3.isChecked) {
                    menuIds.push(item3.menuId);
                  }
                });
              }
            });
          }
          if (item.permissions && item.permissions.length > 0) {
            item.permissions.forEach((item2) => {
              if (item2.isChecked) {
                menuIds.push(item2.menuId);
              }
            });
          }
        });
      }
      return menuIds;
    },
    deleteDept() {
      this.$confirm(`确定删除此角色？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        deleteInfo(this.selectRole.roleId).then((res) => {
          if (res.code === 200) {
            this.selectRole.roleId = "";
            this.getRoleData();
          }
        });
      });
    },
  },
};
</script>
<style lang="scss">
.role-permission-management {
  .el-table__header-wrapper {
    position: relative;
  }
  .el-table--border td,
  .el-table--border th,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-right: none;
  }
  .el-checkbox__input.is-disabled + span.el-checkbox__label {
    color: #666666;
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #1268ff;
  }
}
</style>
<style lang="scss" scoped>
.role-permission-management {
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  padding: 0.2rem;
  .staff-left {
    width: 3rem;
    height: 100%;
    background-color: #ffffff;
    flex-shrink: 0;
    border-radius: 0.08rem;
    padding: 0.2rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .tree-search {
      flex-shrink: 0;
    }
    .role-box {
      flex: 1;
      overflow-y: auto;
      padding-top: 0.1rem;
      .role-box-list {
        width: 100%;
        height: 0.36rem;
        display: flex;
        align-items: center;
        cursor: pointer;
        .people-icon {
          width: 0.2rem;
          height: 0.2rem;
          margin: 0 0.04rem 0 0.06rem;
        }
        span {
          font-size: 0.14rem;
          color: #434343;
        }
      }
      .role-box-list-selected {
        background: #eaeff5;
        border-radius: 0.06rem;
      }
    }
    .add-dept {
      width: 100%;
      height: 0.32rem;
      background-color: #eaf1ff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.14rem;
      color: #1269ff;
      cursor: pointer;
    }
  }
  .staff-right {
    flex: 1;
    height: 100%;
    background-color: #ffffff;
    border-radius: 0.08rem;
    margin-left: 0.2rem;
    display: flex;
    flex-direction: column;
    .custom-table-box {
      padding: 0 0.1rem 0.2rem;
    }
    .top-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.1rem 0 0.2rem;
      .top-box-left {
        display: flex;
        align-items: center;
        .company-image {
          width: 0.2rem;
          height: 0.2rem;
        }
        .company-box {
          display: flex;
          align-items: center;
          .name {
            color: #000000;
            font-size: 0.18rem;
            padding-left: 0.1rem;
            padding-right: 0.1rem;
          }
          .sub-name {
            color: #000000;
            font-size: 0.14rem;
          }
          .tree-image {
            width: 0.2rem;
            height: 0.2rem;
            margin-left: 0.04rem;
          }
        }
      }
      .top-box-right {
        .box-1 {
          color: #1269ff;
          cursor: pointer;
          position: relative;
          padding-right: 0.2rem;
          &:hover {
            text-decoration: underline;
          }
        }
        .box-1:before {
          position: absolute;
          content: "";
          right: 0.1rem;
          top: 0.04rem;
          width: 0.01rem;
          height: 0.12rem;
          background-color: #d9d9d9;
        }
        .box-1:nth-last-of-type(1) {
          padding-right: 0.1rem;
        }
        .box-1:nth-last-of-type(1):before {
          display: none;
        }
      }
    }
  }
  .search-form-box {
    flex-shrink: 0;
  }
  .custom-table-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    .list-1 {
      width: 25%;
      padding-left: 0.12rem;
      box-sizing: border-box;
    }
    .list-2 {
      width: 25%;
      padding-left: 0.12rem;
      box-sizing: border-box;
      .list-checkbox {
        margin: 0.1rem 0;
      }
    }
    .list-3 {
      width: 50%;
      padding-left: 0.12rem;
      box-sizing: border-box;
    }
    .custom-role-header {
      flex-shrink: 0;
      display: flex;
      position: relative;
      .edit-or-save {
        position: absolute;
        right: 0.2rem;
        color: #1268ff;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .custom-role-header {
      background-color: #f0f5ff;
      color: #000000;
      padding: 0.12rem;
      font-family: pm, serif;
    }
    .custom-role-content {
      flex: 1;
      overflow-y: auto;
      width: 100%;

      .role-table-box {
        display: flex;
        padding: 0.1rem 0;
        .list-table-1 {
          width: 25%;
          display: flex;
          align-items: center;
          padding-left: 0.12rem;
          box-sizing: border-box;
        }
        .list-table-2 {
          width: 75%;
          padding-left: 0.12rem;
          box-sizing: border-box;
          .table-2-1 {
            width: 100%;
            display: flex;
            .list-2-1 {
              width: 100%;
              display: flex;
              .list {
                width: 25%;
                margin: 0.1rem;
                .list-box {
                  height: 100%;
                  display: flex;
                  align-items: center;
                }
              }
              .list2 {
                width: 75%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                padding: 0.1rem 0;
              }
            }
          }
        }
      }
      .role-table-box:nth-child(2n - 2) {
        background-color: #fbfcff;
      }
    }
  }
}
</style>
